import { z } from "zod/v4-mini";

import { BasePumpEvent } from "@/models/InsulinPumpEvents.ts";
import { Schema, cz } from "@/utils/zodUtils.ts";

export type InsulinBasalRate = BasePumpEvent & {
  basalRate: number;
  tempRate: boolean;
  tempRatePercent: number;
};

export const insulinBasalRateSchema: Schema<InsulinBasalRate> = cz.camelCaseObject({
  id: cz.id(),
  date: cz.datetime(),
  basal_rate: z.number(),
  temp_rate: z.boolean(),
  temp_rate_percent: z.number(),
});
